module.exports = __webpack_public_path__ + "static/sport/title.01215eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/football/pc/title.png
// module id = BHt4
// module chunks = 0